import { render, staticRenderFns } from "./MemberReviewExpired.vue?vue&type=template&id=096d109a&scoped=true"
import script from "./MemberReviewExpired.vue?vue&type=script&lang=js"
export * from "./MemberReviewExpired.vue?vue&type=script&lang=js"
import style0 from "./MemberReviewExpired.vue?vue&type=style&index=0&id=096d109a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096d109a",
  null
  
)

export default component.exports